import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-financials',
  name: 'Access Financials',
  category: 'access-integrations',
  description: 'Execute GraphQL queries against Access Financials API (Data, Dimensions, System endpoints) with built-in Access Identity authentication',
  icon: 'DollarSign',
  color: 'orange',
  version: '1.0.0',
  comingSoon: false,

  defaults: {
    name: 'Access Financials',
    color: '#f97316', // orange-500
  },

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  tags: ['access', 'financials', 'graphql', 'erp', 'accounting'],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'access_financials_query',
    description: 'Execute GraphQL queries against Access Financials API. Supports Data, Dimensions, and System endpoints for financial data retrieval.',
    allowManualDescription: true,
    parameters: {
      endpointType: {
        toolParamName: 'endpoint_type',
        description: 'The endpoint type: data, dimensions, system, or dimensions-system',
        required: true,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'The GraphQL query string',
        required: true,
        type: 'string',
      },
      variables: {
        toolParamName: 'variables',
        description: 'GraphQL variables as a JSON object',
        required: false,
        type: 'object',
      },
      instanceId: {
        toolParamName: 'instance_id',
        description: 'The Financials database instance ID',
        required: true,
        type: 'string',
      },
    },
    outputMapping: {
      data: 'GraphQL response data',
      errors: 'GraphQL errors if any occurred',
      hasErrors: 'Boolean indicating if errors occurred',
    },
  },
};

export default definition;
